var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303 70a47 47 0 1 0-70 40v84h46v-84c14-8 24-23 24-40z",
    fill: "#93c7ef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 23v171h23v-84a47 47 0 0 0-23-87z",
    fill: "#5a8bb0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#93c7ef",
    d: "M0 240h248v124H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a8bb0",
    d: "M264 240h248v124H264z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#93c7ef",
    d: "M186 365h140v124H186z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a8bb0",
    d: "M256 365h70v124h-70z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce9f9",
    d: "M47 163h419v279H47z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#93c7ef",
    d: "M256 163h209v279H256z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194 272a31 31 0 0 1-62 0c0-18 14-32 31-32s31 14 31 32z",
    fill: "#3c5d76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M380 272a31 31 0 0 1-62 0c0-18 14-32 31-32s31 14 31 32z",
    fill: "#1e2e3b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186 349a70 70 0 1 0 140 0H186z",
    fill: "#3c5d76"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256 349v70c39 0 70-31 70-70h-70z",
    fill: "#1e2e3b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.c8bc08a57080b00d3c6cef8da79e6123.svg";
export { ForwardRef as ReactComponent };